import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { sitesSlice } from '../../common/reducers/sites';

const GUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const readMetaSiteIdFromUrl = (): string | null => {
  const metaSiteId = new URLSearchParams(window.location.search).get('metaSiteId');
  return metaSiteId && GUID_REGEX.test(metaSiteId) ? metaSiteId : null;
};

export const useInitialMetaSiteIdFromUrl = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const metaSiteId = readMetaSiteIdFromUrl();
    if (metaSiteId) {
      dispatch(sitesSlice.actions.setCopilotMetaSiteId(metaSiteId));
    }
  }, [dispatch]);
};
